<template>
  <div class="page page--step2">
    <div class="container">
      <div class="panel">
        <div class="panel-header">
          <h1>Now we just need to check&hellip;</h1>
        </div>

        <div class="panel-body panel-body-flush">
          <Questions
            ref="questions"
            :section="1"
            previous-route="survey.step-1"
            next-route="survey.step-3"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Questions from "@/components/Survey/Questions"

export default {
  components: {
    Questions,
  },

  mounted() {
    this.goToStartIfNecessary();

    this.setCurrentStep(2);

    this.scrollToTop();
  },
};
</script>

<style lang="scss">
  .page--step2 .question-title p:not(:first-child):last-child {
    padding: 1rem 1.25rem;
    border-radius: 0.25rem;
    color: $alert-danger-fg;
    background-color: $alert-danger-bg;
    border-color: $alert-danger-border-color;
  }
</style>
